import React, { useState } from "react";
import "./Banner.css";

import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";
import Common_Form from "../../common_components/common_form/Common_Form";

const Banner = () => {
  const [modalshow, setmodalshow] = useState(false);

  return (
    <section className="banner_section" id="home">
      <div className="banner_wrapper">
        {/* Desktop Banner */}
        <div className="admission_banner">
          <img
            src="/assets/images/banner/banner2.webp"
            alt="Online MBA Banner"
            className="banner_img"
          />
        </div>

        {/* Mobile Banner */}
        <div className="admission_banner mobile_banner">
          <img
            src="/assets/images/banner/banner2.webp"
            alt="Admission Banner"
            className="admission_img"
          />
          <div className="banner_left_img"></div>
        </div>

        {/* Enquiry Form */}
        <div className="banner_form">
          <Common_Form />
        </div>

        {/* Eligibility Strip */}

        {/*
        <div className="eligibility_wrapper">
          <span className="eligibility_label">Eligibility</span>
          <span className="eligibility_text">
            Graduate in any discipline from a recognized University.
            Minimum 50% for General category and 45% for Reserved category
            students.
          </span>
        </div>
        */}
      </div>

      {/* Inquiry Modal */}
      <InquiryFormModal
        show={modalshow}
        onHide={() => setmodalshow(false)}
        modalshow={modalshow}
        setmodalshow={setmodalshow}
      />
    </section>
  );
};

export default Banner;
